import { lazyLoad } from 'utils/loadable';

export const SignInHelpPage = lazyLoad(
  () => import('./SignInHelpPage'),
  module => module.SignInHelpPage,
);
